import styles from "../../PostJobPage/PostJob.module.scss";
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import React from "react";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

interface ErrorModalProps {
    message: string;
    title?: string;
    onCloseButtonClick: (e: any) => void;
    onGoPaymentInfoPageClick: (e: any) => void;
}

export const ErrorModal = ({message, title = 'Cannot Post Job', onCloseButtonClick, onGoPaymentInfoPageClick}: ErrorModalProps) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>{title}</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                {message}
            </div>
            <StyledButton
                variant="contained"
                size="large"
                onClick={onGoPaymentInfoPageClick}
                className={clsx(styles.okButton)}
            >
                Go to Update Payment Info Page
            </StyledButton>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx(styles.okButton)}
            >
                Close
            </StyledButton>
        </>
    );
}